// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
// import Label from '../../components/Label';
import SvgIconStyle from '../../components/SvgIconStyle';
// import ListAltIcon from '@mui/icons-material/ListAlt';
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
  list: getIcon('ic_list'),
  list2: getIcon('ic_list2')
};

const allow = true;

export const sidebarConfigExtra = [
  {
    subheader: 'Crece',
    // // roles: ['plus'],
    etiquetaPermitida: 'crece',
    // allow,
    items: [
      {
        title: 'Dashboard',
        path: PATH_DASHBOARD.crece.main,
        icon: ICONS.kanban,
        // // roles: ['plus'],
        etiquetaPermitida: 'crece-dashboard',
        allow
      },
      {
        title: 'Paquetes',
        path: PATH_DASHBOARD.crece.sucursal,
        icon: ICONS.kanban,
        // // roles: ['plus'],
        etiquetaPermitida: 'crece-paquetes',
        allow
      },
      {
        title: 'Repartos',
        path: PATH_DASHBOARD.crece.repartos,
        icon: ICONS.kanban,
        // // roles: ['plus'],
        etiquetaPermitida: 'crece-repartos',
        allow
      }
    ]
  }
];

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'Inicio',
  //   items: [
  //     {
  //       title: 'inicio',
  //       path: PATH_DASHBOARD.general.app,
  //       icon: ICONS.dashboard
  //     }
  //   ]
  // },
  {
    subheader: 'Paquetes',
    // roles: ['usuario', 'plus', 'cliente-licenciatario', 'basic'],
    idSection: 'PAQUETES',
    allow,
    items: [
      {
        title: 'Envios',
        path: PATH_DASHBOARD.paquetes.envios,
        icon: ICONS.kanban,
        // roles: ['usuario', 'plus', 'cliente-licenciatario', 'basic'],
        id: 'ENVIOS',
        allow
      },
      {
        title: 'Venta empaque',
        path: PATH_DASHBOARD.paquetes.productos,
        icon: ICONS.kanban,
        // roles: ['usuario', 'plus', 'cliente-licenciatario', 'basic'],
        id: 'EMPAQ_PRODUCTOS',
        allow
      },

      {
        title: 'Pick Up',
        path: PATH_DASHBOARD.paquetes.pickup,
        icon: ICONS.kanban,
        // roles: ['superusuario', 'plus', 'cliente-licenciatario'],
        id: 'PICKUP',
        allow
      },
      {
        title: 'Recoleccion',
        path: PATH_DASHBOARD.paquetes.recoleccion,
        icon: ICONS.kanban,
        // roles: ['superusuario', 'plus', 'cliente-licenciatario'],
        id: 'RECOLECCION',
        allow
      },
      {
        title: 'Transacciones',
        path: PATH_DASHBOARD.paquetes.transaccion,
        icon: ICONS.kanban,
        // roles: ['superusuario', 'plus'],
        id: 'TRANSACCION',
        allow
      }
    ]
  },
  {
    subheader: 'Olimpo',
    // roles: ['usuario', 'plus', 'cliente-licenciatario', 'basic'],
    idSection: 'OLIMPO',
    allow,
    items: [
      {
        title: 'Olimpo',
        path: PATH_DASHBOARD.olimpo.olimpo,
        icon: ICONS.kanban,
        // roles: ['usuario', 'plus', 'cliente-licenciatario', 'basic'],
        id: 'OLIMPO',
        allow
      },
      {
        title: 'Help Desk',
        path: PATH_DASHBOARD.olimpo.olimpoReports,
        icon: ICONS.kanban,
        id: 'OLIMPO_REPORTS',
        allow
      }
    ]
  },
  {
    subheader: 'licenciatarios',
    // roles: ['usuario', 'plus', 'cliente-licenciatario', 'basic'],
    idSection: 'LICENCIATARIOS',
    allow,
    items: [
      {
        title: 'Caja',
        path: PATH_DASHBOARD.licenciatarios.caja,
        icon: ICONS.kanban,
        // roles: ['usuario', 'plus', 'cliente-licenciatario', 'basic'],
        id: 'CAJA',
        allow
      },
      {
        title: 'Mis tickets',
        path: PATH_DASHBOARD.licenciatarios.tickets,
        icon: ICONS.kanban,
        // roles: ['usuario', 'plus', 'cliente-licenciatario', 'basic'],
        id: 'MIS_TICKETS',
        allow
      },
      {
        title: 'Cajeros',
        path: PATH_DASHBOARD.licenciatarios.asignedUsers,
        icon: ICONS.kanban,
        // roles: ['usuario', 'plus', 'cliente-licenciatario', 'basic'],
        id: 'USUARIO_ASIGNADO',
        allow
      }
    ]
  },
  // {
  //   subheader: 'general',
  //   items: [
  //     {
  //       title: 'app',
  //       path: PATH_DASHBOARD.general.app,
  //       icon: ICONS.dashboard
  //     }
  //     /* { title: 'e-commerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
  //     { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
  //     { title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
  //     { title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking } */
  //   ]
  // },
  {
    subheader: 'Funciones',
    // roles: ['dios', 'usuario', 'admin', 'plus', 'superusuario', 'cliente-licenciatario'],
    idSection: 'FUNCIONES',
    allow,
    items: [
      // {
      //   title: 'Lista Cotizaciones',
      //   path: PATH_DASHBOARD.cotizaciones.root,
      //   icon: ICONS.kanban,
      //   // roles: ['plus', 'cliente-licenciatario'],
      //   id: 'ENVIOS',
      //   allow
      // },
      {
        title: 'Nueva Cotizacion',
        path: PATH_DASHBOARD.cotizaciones.new,
        icon: ICONS.ecommerce,
        // roles: ['usuario', 'plus', 'administrativo', 'cliente-licenciatario'],
        id: 'COTIZACION',
        allow
      },
      {
        title: 'Nuevo Envio',
        path: PATH_DASHBOARD.cotizaciones.cotenvio,
        icon: ICONS.cart,
        // roles: ['ususario', 'plus', 'basic'],
        id: 'ENVIO_NUEVO',
        allow
      },
      {
        title: 'Administracion',
        path: PATH_DASHBOARD.cotizaciones.hugo,
        icon: ICONS.cart,
        // roles: ['dios', 'administrativo'],
        id: 'ADMINISTRACION',
        allow
      },
      {
        title: 'Empaque',
        path: PATH_DASHBOARD.cotizaciones.empaque,
        icon: ICONS.cart,
        // roles: ['dios', 'administrativo'],
        id: 'EMPAQUE',
        allow
      },
      {
        title: 'cart',
        path: PATH_DASHBOARD.cotizaciones.cart,
        icon: ICONS.cart,
        // roles: ['usuario', 'plus', 'basic'],
        id: 'CART',
        allow: true
      },
      {
        title: 'wallet',
        path: PATH_DASHBOARD.cotizaciones.wallet,
        icon: ICONS.cart,
        // roles: ['usuario', 'plus', 'basic'],
        id: 'WALLET',
        allow: true
      },
      {
        title: 'Locker',
        path: '/locker',
        icon: ICONS.kanban,
        // roles: ['dios', 'admin'],
        id: 'LOCKER',
        allow
      },
      {
        title: 'Administracion locker',
        path: PATH_DASHBOARD.locker.admin,
        icon: ICONS.kanban,
        // roles: ['dios', 'admin'],
        id: 'ADMINISTRACION_LOCKER',
        allow
      },
      {
        title: 'Operacion user',
        path: PATH_DASHBOARD.locker.operationUser,
        icon: ICONS.kanban,
        // roles: ['dios', 'admin'],
        id: 'OPERACION_LOCKER_USER',
        allow
      },
      {
        title: 'Registro repartidor',
        path: PATH_DASHBOARD.locker.regRepartidor,
        icon: ICONS.kanban,
        // roles: ['dios', 'admin'],
        id: 'REG_REPARTIDOR_LOCKER',
        allow
      },
      {
        title: 'Direciones',
        path: PATH_DASHBOARD.funcUsers.funcionesUser,
        icon: ICONS.kanban,
        // roles: ['dios', 'admin'],
        id: 'FUNCIONES_USER',
        allow
      }
    ]
  },
  // {
  //   subheader: 'Administrativos',
  //   roles: ['dios', 'administrativo'],
  //   allow,
  //   items: [
  //     {
  //       title: 'Lista Usuarios',
  //       path: PATH_DASHBOARD.administrativos.userList,
  //       icon: ICONS.kanban,
  //       roles: ['dios', 'administrativo'],
  //       allow
  //     },
  //     {
  //       title: 'Licenciatarios',
  //       path: PATH_DASHBOARD.administrativos.licenciatarios,
  //       icon: ICONS.kanban,
  //       roles: ['dios', 'administrativo'],
  //       allow
  //     }
  //   ]
  // },

  {
    subheader: 'Servicios',
    // roles: ['plus'],
    idSection: 'SERVICIOS',
    allow,
    items: [
      {
        title: 'Inicio',
        path: PATH_DASHBOARD.servicios.root,
        icon: ICONS.kanban,
        // roles: ['plus'],
        id: 'INICIO',
        allow
      },
      {
        title: 'Registro pagos',
        path: PATH_DASHBOARD.servicios.serviciosRecargas,
        icon: ICONS.kanban,
        // roles: ['plus'],
        id: 'SERVICIO-RECARGA',
        allow
      },
      {
        title: 'Recargas',
        path: PATH_DASHBOARD.servicios.recargas,
        icon: ICONS.kanban,
        // roles: ['plus'],
        id: 'RECARGA',
        allow
      },
      {
        title: 'Servicios',
        path: PATH_DASHBOARD.servicios.servicios,
        icon: ICONS.kanban,
        // roles: ['plus'],
        id: 'PAGO_SERVICIO',
        allow
      }
      // {
      //   title: 'Cliente Corporativo',
      //   path: PATH_DASHBOARD.servicios.clienteCorp,
      //   icon: ICONS.kanban
      // },
      // {
      //   title: 'Puntos Dagpacket',
      //   path: PATH_DASHBOARD.servicios.puntos,
      //   icon: ICONS.kanban
      // },
      // {
      //   title: 'Cajeros',
      //   path: PATH_DASHBOARD.servicios.cajeros,
      //   icon: ICONS.kanban
      // }
    ]
  },
  {
    subheader: 'Crece',
    // roles: ['plus'],
    idSection: 'CRECE',
    allow,
    items: [
      {
        title: 'Main',
        path: PATH_DASHBOARD.crece.main,
        icon: ICONS.kanban,
        // roles: ['plus'],
        id: 'CRECE_MAIN',
        allow
      },
      {
        title: 'Sucursal',
        path: PATH_DASHBOARD.crece.sucursal,
        icon: ICONS.kanban,
        // roles: ['plus'],
        id: 'CRECE_SUCURSAL',
        allow
      },
      {
        title: 'Reparto',
        path: PATH_DASHBOARD.crece.repartos,
        icon: ICONS.kanban,
        // roles: ['plus'],
        id: 'CRECE_REPARTOS',
        allow
      }
    ]
  }

  // MANAGEMENT
  // ----------------------------------------------------------------------
  /* {
    subheader: 'management',
    items: [
      // MANAGEMENT : USER
      {
        title: 'user',
        path: PATH_DASHBOARD.user.root,
        icon: ICONS.user,
        children: [
          { title: 'profile', path: PATH_DASHBOARD.user.profile },
          { title: 'cards', path: PATH_DASHBOARD.user.cards },
          { title: 'list', path: PATH_DASHBOARD.user.list },
          { title: 'create', path: PATH_DASHBOARD.user.newUser },
          { title: 'edit', path: PATH_DASHBOARD.user.editById },
          { title: 'account', path: PATH_DASHBOARD.user.account }
        ]
      },

      // MANAGEMENT : E-COMMERCE
      {
        title: 'e-commerce',
        path: PATH_DASHBOARD.eCommerce.root,
        icon: ICONS.cart,
        children: [
          { title: 'shop', path: PATH_DASHBOARD.eCommerce.shop },
          { title: 'product', path: PATH_DASHBOARD.eCommerce.productById },
          { title: 'list', path: PATH_DASHBOARD.eCommerce.list },
          { title: 'create', path: PATH_DASHBOARD.eCommerce.newProduct },
          { title: 'edit', path: PATH_DASHBOARD.eCommerce.editById },
          { title: 'checkout', path: PATH_DASHBOARD.eCommerce.checkout },
          { title: 'invoice', path: PATH_DASHBOARD.eCommerce.invoice }
        ]
      },

      // MANAGEMENT : BLOG
      {
        title: 'blog',
        path: PATH_DASHBOARD.blog.root,
        icon: ICONS.blog,
        children: [
          { title: 'posts', path: PATH_DASHBOARD.blog.posts },
          { title: 'post', path: PATH_DASHBOARD.blog.postById },
          { title: 'new post', path: PATH_DASHBOARD.blog.newPost }
        ]
      }
    ]
  },

  // APP
  // ----------------------------------------------------------------------
  {
    subheader: 'app',
    items: [
      {
        title: 'mail',
        path: PATH_DASHBOARD.mail.root,
        icon: ICONS.mail,
        info: <Label color="error">2</Label>
      },
      { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
      { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
      {
        title: 'kanban',
        path: PATH_DASHBOARD.kanban,
        icon: ICONS.kanban
      }
    ]
  } */
];

export default sidebarConfig;
